// extracted by mini-css-extract-plugin
export default {"tabs":"styles_tabs__c+1Nv","tab":"styles_tab__iN100","line":"styles_line__9Oapa","active_line":"styles_active_line__AbLAq","num":"styles_num__Niysg"};